import Location from './Location';

export default class Exile extends Location {

	constructor (master) {

		super(master, "exile");
	}
}